import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { capitalize } from 'lodash';
import businessLines from '../../constants/businessLines';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '20px',
    marginRight: '10px',
    lineHeight: '15px',
  },
  buttonRow: {
    padding: '10px',
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'left',
  },
  checkboxRow: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
  },
}));

const LineOfBusinessSelector = ({ selected, options, onChange, title }) => {
  const classes = useStyles();
  const [isSelected, updateSelected] = useState(
    selected.reduce(
      (selections, selection) => ({
        ...selections,
        [selection]: true,
      }),
      {}
    )
  );
  return (
    <div className={classes.buttonRow}>
      <p className={classes.title}>{title}</p>
      <div className={classes.checkboxRow}>
        {options.map(option => (
          <FormControlLabel
            key={`${option}-lob-formik-controller`}
            control={
              <Checkbox
                id={`${option}-checkbox`}
                name={option}
                checked={isSelected[option]}
                onChange={({ target: { checked } }) => {
                  isSelected[option] = checked;
                  updateSelected(isSelected);
                  onChange(options.filter(line => isSelected[line]));
                }}
              />
            }
            label={capitalize(option)}
          />
        ))}
      </div>
    </div>
  );
};

LineOfBusinessSelector.propTypes = {
  title: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  selected: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

LineOfBusinessSelector.defaultProps = {
  title: 'Lines of business:',
  options: businessLines,
  selected: [],
  onChange: () => null,
};

export default LineOfBusinessSelector;
